import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { LuCheck } from 'react-icons/lu';

// Animações
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const zoomIn = keyframes`
  from { transform: scale(0.8); }
  to { transform: scale(1); }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease-out;
`;

const ModalContent = styled.div`
  background: white;
  padding: 40px;
  border-radius: 12px;
  text-align: center;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: ${zoomIn} 0.3s ease-out;
  
  @media (max-width: 768px) {
    padding: 30px 20px;
    max-width: 90%;
  }
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${props => props.theme.colors.successGreen};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Message = styled.p`
  font-size: 16px;
  color: ${props => props.theme.colors.grayDark};
  line-height: 1.5;
  margin-bottom: 25px;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const RedirectMessage = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.grayMedium};
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const SuccessModal = ({ open, contactType = 'email', contactValue = '', onBeforeRedirect }) => {
  const [countdown, setCountdown] = useState(15);
  const redirectUrl = 'https://santacasacopacabana.com.br/';
  const isWhatsApp = contactType === 'whatsapp';

  useEffect(() => {
    let timer;
    let redirectTimeout;

    if (open) {
      setCountdown(15);

      // Inicia o contador regressivo
      timer = setInterval(() => {
        setCountdown(prev => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      // Agenda o redirecionamento
      redirectTimeout = setTimeout(() => {
        if (typeof onBeforeRedirect === 'function') {
          onBeforeRedirect();
        }
        window.location.href = redirectUrl;
      }, 15000);
    }

    // Função de limpeza: cancela os timers se o componente for desmontado
    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimeout);
    };
  }, [open, redirectUrl, onBeforeRedirect]);

  if (!open) {
    return null;
  }

  return (
    <ModalOverlay>
      <ModalContent>
        <SuccessIcon><LuCheck size={40} /></SuccessIcon>
        <Title>Solicitação enviada</Title>
        <Message>
          Enviamos o link de confirmação por <strong>{isWhatsApp ? 'WhatsApp' : 'e-mail'}</strong>
          {contactValue && (
            <>
              {' '}para <strong>{contactValue}</strong>
            </>
          )}
          . Abra a mensagem e siga o link para finalizar sua contratação.
        </Message>
        <RedirectMessage>
          Levamos você de volta ao site em <strong>{countdown}</strong> segundos.
        </RedirectMessage>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SuccessModal;